import {ReportLayoutManager} from 'common/report/contexts/report-layout';
import {contextify, createRootContextHook} from 'common/util/react';

const context = contextify<ReportLayoutManager>();

export const ReportLayoutManagerProvider = context.Provider;
export const ReportLayoutManagerConsumer = context.Consumer;
export const useReportLayoutManager = createRootContextHook(`reportLayoutManager`);
